import React from 'react';
import { ModalBody } from './body';
import { ModalFooter } from './footer';
import { ModalHeader } from './header';

const Modal = ({ children, isOpen, isLarge }) => {
    return (
        <>
            <div className={`modal fade ${isOpen ? 'show' : ''}`} tabIndex="-1" aria-hidden="true">
                <div className={`modal-dialog  modal-dialog-centered ${isLarge ? 'modal2' : 'modal3'}`}>
                    <div className="modal-content">
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
};
export {
    Modal, ModalBody, ModalFooter, ModalHeader
}